// extracted by mini-css-extract-plugin
export default {"editParamsDrawer":"NewEditDrawer_editParamsDrawer__CBXT1"};